import React from 'react';
import { NotificationPreference } from '../profileTypes';
import styles from './NotificationPreferences.module.css';

interface NotificationPreferencesProps {
  preferences: NotificationPreference[];
  onToggle?: (id: string) => void;
}

export const NotificationPreferences: React.FC<NotificationPreferencesProps> = ({
  preferences,
  onToggle,
}) => {
  return (
    <div className={styles.card}>
      <div className={styles.header}>
        <svg viewBox="0 0 24 24" fill="currentColor" className={styles.headerIcon}>
          <path d="M12 22c1.1 0 2-.9 2-2h-4c0 1.1.89 2 2 2zm6-6v-5c0-3.07-1.64-5.64-4.5-6.32V4c0-.83-.67-1.5-1.5-1.5s-1.5.67-1.5 1.5v.68C7.63 5.36 6 7.92 6 11v5l-2 2v1h16v-1l-2-2z" />
        </svg>
        <h3 className={styles.title}>Notification Preferences</h3>
      </div>
      <div className={styles.list}>
        {preferences.map((pref) => (
          <div key={pref.id} className={styles.item}>
            <span className={styles.label}>{pref.label}</span>
            <label className={styles.toggle}>
              <input
                type="checkbox"
                checked={pref.enabled}
                onChange={() => onToggle?.(pref.id)}
                className={styles.checkbox}
              />
              <span className={styles.checkboxVisual}>
                {pref.enabled && (
                  <svg viewBox="0 0 24 24" fill="currentColor" className={styles.checkIcon}>
                    <path d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z" />
                  </svg>
                )}
              </span>
            </label>
          </div>
        ))}
      </div>
    </div>
  );
};
